import React from "react"


const IndexPage = () => (
    <div>
     <h1>Web Site</h1>
    </div>
)

export default IndexPage
